<template>
  <PlatformLayout :useOverlay="overlay">
    <v-container fluid>
      <xlsx-read :file="file">
        <xlsx-json @parsed="imported"></xlsx-json>
      </xlsx-read>
      <h2 class="text-center">Importación de clientes</h2>
      <v-row>
        <v-col cols="4" offset="4">
          <v-file-input
            :rules="rules"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            placeholder="Selecciona tu archivo excel"
            label="Archivo a importar"
            show-size
            @change="onChange"
          ></v-file-input>
        </v-col>
        <v-col cols="8" class="mx-auto" v-if="clientesImport.length > 0">
          <h3>Clientes a importar</h3>
          <br />
          <v-alert color="blue" type="info">
            Revise la información de los clientes. Recuerde que ésta se puede
            editar más adelante en el módulo de Clientes.
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="clientesImport.length > 0 && errores.length == 0">
        <v-col cols="8" class="mx-auto">
          <v-btn @click="uploadNewClients"
            ><v-icon>mdi-account-arrow-up-outline</v-icon>&nbsp;DAR DE
            ALTA</v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="errores.length > 0">
        <v-col cols="8" class="mx-auto">
          <h3>Errores de formato</h3>
          <br />
          <v-alert color="red" type="error">
            El formato proporcionado presenta los siguientes errores.
            <br />
            <v-list-item class="text-center">
              <v-list-item-content
                v-for="(error, index) of errores"
                :key="index"
              >
                {{ error }}
              </v-list-item-content>
            </v-list-item>
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="clientesImport.length > 0">
        <v-col cols="8" class="mx-auto">
          <v-data-table
            :headers="headers"
            :items="clientesImport"
            :items-per-page="-1"
            class="elevation-3"
            :footer-props="{
              itemsPerPageText: 'El. por página',
              itemsPerPageAllText: 'Todo',
              itemsPerPageOptions: ippoptions,
            }"
            no-data-text="No hay datos para mostrar"
          >
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </PlatformLayout>
</template>

<script>
import PlatformLayout from "@/components/PlatformLayout.vue";
import { XlsxRead, XlsxJson } from "vue-xlsx";
import { httpPost } from "@/services/apiService";

export default {
  name: "ImportacionClientes",
  components: {
    PlatformLayout,
    XlsxRead,
    XlsxJson,
  },
  data() {
    return {
      file: null,
      clientesImport: [],
      rules: [
        (value) =>
          !value ||
          value.size < 20000000 ||
          "El archivo no puede ser mayor que 20 MB.",
      ],
      headers: [
        {
          text: "Nombre",
          align: "center",
          sortable: false,
          value: "nombre",
        },
        {
          text: "Correo",
          align: "center",
          sortable: false,
          value: "correo",
        },
        {
          text: "Teléfono",
          align: "center",
          sortable: false,
          value: "telefono",
        },
        {
          text: "RFC",
          align: "center",
          sortable: false,
          value: "rfc",
        },
      ],
      ippoptions: [-1],
      errores: [],
      overlay: false,
    };
  },
  methods: {
    onChange(event) {
      this.file = event;
    },
    async imported(event) {
      this.overlay = true;
      if (this.file == null) {
        this.overlay = false;
        this.$toasted.show(
          "No se ha podido detectar formato adecuado en el archivo, revisarlo",
          {
            type: "error",
          }
        );
        return;
      }

      for (let [index, item] of event.entries()) {
        if (index == 0) {
          continue;
        }
        this.clientesImport.push({
          nombre: item["NOMBRE"] || null,
          correo: item["CORREO"]
            ? item["CORREO"].toString().replace(/\s/g, '')
            : null,
          telefono: item["TELEFONO"]
            ? item["TELEFONO"].toString().trim()
            : null,
          rfc: item["RFC"] ? item["RFC"].toString().trim() : null,
          cp: item["CP"] ? item["CP"].toString().trim() : null,
        });
      }
      this.overlay = false;
    },
    async uploadNewClients() {
      this.overlay = true;
      const { data } = await httpPost("/clientes/bulk-upload", {
        data: { clients: this.clientesImport },
      }).catch((err) => {
        this.$toasted.show(
          "Ha ocurrido un error, no se puede cargar el formato, hable a soporte",
          {
            type: "error",
          }
        );
        this.overlay = false;
      });

      this.$toasted.show(data?.message, {
        type: "success",
      });

      this.clientesImport = [];
      this.overlay = false;
      this.$router.push({ path: "/platform/clientes" });
    },
  },
};
</script>
